<template>
  <div class="member-page">
    <main class="member-page-main">
      <aside class="member-pay-panel">
        <section class="countdown-section">
          <div class="countdown-title">今日活动仅剩</div>
          <div class="countdown-row">
            <span class="time-box">{{ String(countdown.hours).padStart(2, '0') }}</span>
            <span class="time-dot">:</span>
            <span class="time-box">{{ String(countdown.minutes).padStart(2, '0') }}</span>
            <span class="time-dot">:</span>
            <span class="time-box">{{ String(countdown.seconds).padStart(2, '0') }}</span>
            <span class="time-dot">:</span>
            <span class="time-box">{{ String(countdown.milliseconds).padStart(2, '0') }}</span>
          </div>
        </section>

        <section class="price-section">
          <div class="pay-price-label">实付价</div>
          <div class="pay-price"><span class="pay-price-symbol">￥</span>{{ formatPrice(payInfo.payablePrice) }}</div>
        </section>

        <section class="qr-section">
          <div v-if="isAlipayForm && payQrCode" ref="iframeContainer" class="qr-box" v-loading="isLoadingPayQr">
            <iframe class="qr-iframe" :srcdoc="payQrCode" width="150" height="158" frameborder="0"
              sandbox="allow-scripts allow-forms allow-same-origin"></iframe>
          </div>
          <el-image v-else :src="payQrCode" class="qr-box" v-loading="isLoadingPayQr">
            <template #error>
              <div class="qr-empty"></div>
            </template>
          </el-image>
          <div class="qr-tip">微信/支付宝扫码支付</div>
        </section>

        <section class="order-card">
          <h3 class="panel-card-title">订单信息</h3>
          <div class="order-row">
            <span class="order-row-label">套餐名称</span>
            <strong class="order-row-value">{{ payTitle || '-' }}</strong>
          </div>
          <div class="order-row">
            <span class="order-row-label">原价</span>
            <strong class="order-row-value">￥{{ payInfo.originalPrice || 0 }}</strong>
          </div>
          <div class="order-row" v-if="discountAmount > 0">
            <span class="order-row-label">限时优惠</span>
            <strong class="order-row-value discount-text">-￥{{ formatPrice(discountAmount) }}</strong>
          </div>
          <div class="order-row" v-if="couponDiscountAmount > 0">
            <span class="order-row-label">优惠券</span>
            <strong class="order-row-value discount-text">-￥{{ couponDiscountAmountText }}</strong>
          </div>
        </section>

        <!-- <button class="coupon-card" type="button" @click="openMemberCouponModal">
          <div class="coupon-icon">券</div>
          <span class="coupon-card-label">优惠券</span>
          <strong class="coupon-card-value">{{ couponCardValue }}</strong>
        </button> -->

        <section class="pay-method-card">
          <h3 class="panel-card-title">支付方式</h3>
          <button class="pay-method" :class="{ active: activePayment === 'ALIPAY' }" type="button"
            @click="changPay('ALIPAY')">
            <img class="pay-method-icon" :src="zfb" alt="" />
            <span class="pay-method-label">支付宝</span>
            <span class="check-mark"></span>
          </button>
          <button class="pay-method" :class="{ active: activePayment === 'WECHAT' }" type="button"
            @click="changPay('WECHAT')">
            <img class="pay-method-icon" :src="wechat" alt="" />
            <span class="pay-method-label">微信支付</span>
            <span class="check-mark"></span>
          </button>
          <div class="policy-text">
            支付代表同意
            <a class="policy-text-link" :href="payPolicyUrl" target="_blank">《一点PPT消费协议》</a>
          </div>
        </section>
      </aside>

      <section class="member-content">
        <div class="content-card">
          <h1 class="content-card-title">会员权益</h1>

          <section class="profile-banner">
            <div class="profile-left">
              <el-avatar :size="58" :src="userInfo.head" />
              <div>
                <div class="profile-name">{{ userInfo.name || '' }}</div>
                <div class="profile-id">用户ID：{{ userInfo.shortId || userInfo.number || '' }}</div>
                <div class="profile-vip" v-if="userInfo?.vip?.vipType">
                  <span class="profile-vip-badge">{{ userInfo?.vip?.vipType || '' }}</span>
                  <em class="profile-vip-expire">有效期至：{{ userInfo?.vip?.expireTime || '' }}</em>
                </div>
              </div>
            </div>
            <div class="diamond-area" aria-hidden="true"></div>
          </section>

          <el-tabs
            v-if="visibleTabCount > 0"
            ref="memberTabsRef"
            v-model="activeName"
            class="member-tabs-container"
            :class="{ 'single-tab-title': visibleTabCount === 1 }"
            :before-leave="handleBeforeTabLeave"
            @tab-change="handleTabClick"
            @tab-click="handleClick"
          >
            <el-tab-pane v-if="hasMemberPlans" name="Member">
              <template #label>
                <div class="tab-label">
                  <span class="tab-icon member-icon" aria-hidden="true"></span>
                  <div class="tab-info">
                    <strong class="tab-title">会员套餐</strong>
                    <p class="tab-desc">适合个人用户，享受核心权益</p>
                  </div>
                </div>
              </template>
              <div class="plans-panel">
                <div class="plans-head">
                  <strong class="plans-head-title">选择充值档位</strong>
                </div>
                <div class="payment-card member-plan-card" ref="paymentCardRef2" @mousedown="handleMouseDown">
                  <div v-for="(item, index) in memberData" :key="index" class="card-item"
                    :class="{ active: activeCards === item.code }" @click="handleCardClick(item, $event)">
                    <div class="card-main">
                      <div class="card-name">
                        <span class="card-name-txt">{{ item.name }}</span>
                        <!-- <img  :src="svipBadge" alt="" /> -->
                        <img v-if="hasSvipTag(item)" class="card-name-badge" :src="svipBadge" alt="" />
                        <img v-else class="card-name-badge" :src="vipBadge" alt="" />
                      </div>
                      <div class="price-row">
                        <strong class="price-row-amount"><span class="price-row-symbol">￥</span>{{ getDisplayPlanPrice(item, 'Member')
                        }}</strong>
                        <em class="price-row-tag" v-if="getCenterTag(item)">{{ getCenterTag(item) }}</em>
                        <del class="price-row-original">￥{{ item.originalPrice }}</del>
                      </div>
                    </div>
                    <p class="card-item-desc">{{ item.description }}</p>
                    <div v-if="getHotBuyText(item)" class="hot-buy">{{ getHotBuyText(item) }}</div>
                    <span class="select-corner"></span>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane v-if="hasFuelPlans" name="Integral">
              <template #label>
                <div class="tab-label">
                  <span class="tab-icon gift" aria-hidden="true"></span>
                  <div class="tab-info">
                    <strong class="tab-title">{{ fuelTabTitle }}</strong>
                    <p class="tab-desc">{{ fuelTabDesc }}</p>
                  </div>
                </div>
              </template>
              <div class="plans-panel integral-panel">
                <section v-if="hasIntegralPlans" class="integral-plan-group">
                  <div class="plans-head">
                    <strong class="plans-head-title">选择积分档位</strong>
                    <a class="plans-head-link" :href="integralRuleUrl" target="_blank">详情<el-icon :size="16">
                        <ArrowRight />
                      </el-icon></a>
                  </div>
                  <div class="payment-card" ref="paymentCardRef" @mousedown="handleMouseDown">
                    <div v-for="(item, index) in integralData" :key="'integral-' + index" class="card-item"
                      :class="{ active: activeCards === item.code }" @click="handleCardClick(item, $event)">
                      <div class="card-main">
                        <div class="card-name">
                          <span>{{ item.name }}</span>
                          <img v-if="hasSvipTag(item)" class="card-name-badge" :src="svipBadge" alt="" />
                        </div>
                        <div class="price-row">
                          <strong class="price-row-amount">
                            <span class="price-row-symbol">￥</span>{{ getDisplayPlanPrice(item, 'Integral') }}
                          </strong>
                          <em class="price-row-tag" v-if="getCenterTag(item)">{{ getCenterTag(item) }}</em>
                          <del class="price-row-original"
                            v-if="userInfo.vip?.vip || item.code === 'integral_app_2004'">￥{{ item.originalPrice
                            }}</del>
                          <small class="price-row-vip" v-else>会员价￥{{ item.vipPayPrice }}</small>
                        </div>
                      </div>
                      <p class="card-item-desc">{{ item.description }}</p>
                      <div v-if="getHotBuyText(item)" class="hot-buy">{{ getHotBuyText(item) }}</div>
                      <span class="select-corner"></span>
                    </div>
                  </div>
                </section>

                <section v-if="hasDurationPlans" class="integral-plan-group duration-group">
                  <div class="plans-head duration-head">
                    <strong class="plans-head-title">音频转写时长（仅限AI会议助手使用）</strong>
                  </div>
                  <div class="payment-card duration-card" ref="durationCardRef" @mousedown="handleMouseDown">
                    <div v-for="(item, index) in durationData" :key="'duration-' + index" class="card-item"
                      :class="{ active: activeCards === item.code }" @click="handleCardClick(item, $event)">
                      <div class="card-main">
                        <div class="card-name">{{ item.name }}</div>
                        <div class="price-row">
                          <strong class="price-row-amount"><span class="price-row-symbol">￥</span>{{ getDisplayPlanPrice(item, 'Integral') }}</strong>
                          <small class="price-row-vip"
                            v-if="!userInfo.vip?.vip && item.code != 'integral_app_2004'">会员价￥{{ item.vipPayPrice
                            }}</small>
                          <del class="price-row-original" v-else>￥{{ item.originalPrice }}</del>
                        </div>
                      </div>
                      <div v-if="getHotBuyText(item)" class="hot-buy">{{ getHotBuyText(item) }}</div>
                      <p class="card-item-desc">{{ item.description }}</p>
                      <span class="select-corner"></span>
                    </div>
                  </div>
                </section>
              </div>
            </el-tab-pane>
          </el-tabs>

          <template v-if="activeName === 'Member'">
            <section class="rights-compare">
              <div class="title">
                <h2 class="member-section-title">会员权益对比 </h2>
                <a :href="integralRuleUrl" target="_blank"
                  class="flex items-center gap-1 text-[14px] text-[#827777] cursor-pointer hover:text-[#FF6249]">
                  <span>详情</span>
                  <el-icon :size="14">
                    <ArrowRight />
                  </el-icon>
                </a>
              </div>
              <div class="compare-table" :style="{ '--rights-column-count': rightsColumns.length }">
                <div class="compare-table-scroll scrollbar-style">
                  <div class="compare-row compare-head">
                    <span class="compare-cell compare-cell-name">权益项目</span>
                    <span v-for="column in rightsColumns" :key="column.key" class="rights-column-title"
                      :class="{ current: column.key === currentRightsColumnKey }">
                      <img class="rights-column-icon" :src="column.icon" alt="" />
                      {{ column.name }}
                    </span>
                  </div>
                  <div v-for="row in visibleRightsCompare" :key="row.name" class="compare-row">
                    <span class="compare-cell compare-cell-name">{{ row.name }}</span>
                    <span v-for="cell in row.cells" :key="cell.key" class="compare-cell"
                      :class="{ current: cell.key === currentRightsColumnKey }">
                      <img v-if="cell.type === 'icon'" :src="cell.checked ? trueIcon : falseIcon" alt=""
                        class="rights-status-icon" />
                      <template v-else>
                        <span class="rights-cell-text">{{ cell.text }}</span>
                        <span v-if="cell.subText" class="rights-cell-sub-text">{{ cell.subText }}</span>
                      </template>
                    </span>
                  </div>
                </div>
                <button class="expand-btn" type="button" @click="isRightsExpanded = !isRightsExpanded">
                  {{ isRightsExpanded ? '收起' : '展开' }}
                  <span class="expand-arrow" :class="{ up: isRightsExpanded }"></span>
                </button>
              </div>
            </section>

            <section v-if="pptTemplates.length" class="template-section">
              <h2 class="member-section-title">PPT<span class="member-section-title-accent">模版</span>限时领取</h2>
              <div class="template-grid" :class="{ scrollable: canScrollPptTemplates }">
                <div v-for="item in pptTemplates" :key="item.id || item.title" class="template-card"
                  @click="handlePptTemplateClick(item)">
                  <div class="template-thumb" :class="{ locked: pptLimitedTemplateLocked }"
                    :style="item.cover ? { backgroundImage: `url(${item.cover})` } : undefined">
                    <span class="template-thumb-badge">会员专享</span>
                    <img v-if="pptLimitedTemplateLocked" :src="giftIcon" class="lock" alt="" />
                  </div>
                  <strong class="template-card-title">{{ item.title }}</strong>
                  <p class="template-card-desc">{{ item.desc }}</p>
                </div>
              </div>
            </section>

            <section class="gift-section">
              <h2 class="member-section-title">会员<span class="member-section-title-accent">限时好礼</span></h2>
              <div class="gift-grid">
                <div v-for="item in limitedGifts" :key="item.title" class="gift-card">
                  <div class="gift-logo" aria-hidden="true">
                    <img class="gift-logo-img" :src="item.logo" alt="" />
                  </div>
                  <div class="gift-info">
                    <strong class="gift-title">{{ item.title }}</strong>
                    <p class="gift-desc">{{ item.desc }}</p>
                  </div>
                  <button class="gift-action" type="button" @click="handleLimitedGiftClick">领取</button>
                </div>
              </div>
            </section>

            <section class="team-section">
              <div class="team-section-title-row">
                <h2 class="member-section-title">团队会员</h2>
                <div class="flex items-center gap-1 text-[14px] text-[#827777] cursor-pointer hover:text-[#FF6249]"
                  @click="teamShareRuleVisible = true">
                  <span>什么是团队会员</span>
                  <el-icon :size="14">
                    <ArrowRight />
                  </el-icon>
                </div>
              </div>
              <div class="team-card">
                <div class="sub-accounts">
                  <div class="team-card-head">
                    <strong class="team-card-head-title">团队账号 <em class="team-card-head-desc">子账号可享<span
                          class="team-card-head-highlight !text-[#1858F7]">【{{ relatedTeamVipName }}】</span>权益</em></strong>
                    <span class="team-card-head-count">已添加 <span class="team-card-head-highlight">{{ teamMembers.length
                    }}</span>/{{ maxTeamMembers || 3 }}</span>
                  </div>
                  <div ref="teamSubListRef" class="sub-list" :class="{ dragging: isTeamSubListDragging }"
                    @mousedown="handleTeamSubListMouseDown">
                    <div v-for="(member, index) in teamMembers" :key="member.shortId || member.name || index"
                      class="sub-account active" :class="{ blue: index % 2 === 1 }">
                      <img class="account-crown" :src="teamCrown" alt="" />
                      <el-avatar v-if="member.avatar" :size="40" :src="member.avatar" />
                      <b v-else class="sub-account-avatar-text">子</b>
                      <strong class="sub-account-name">{{ member.name }}</strong>
                      <span class="sub-account-id">ID：{{ member.shortId || '-' }}</span>
                    </div>
                    <button v-for="slot in emptyTeamSlots" :key="'empty-' + slot" class="sub-account add" type="button"
                      @click="handleTeamAddClick">
                      <img class="sub-account-add-icon" :src="addIcon" alt="" />
                      <span class="sub-account-add-text">添加子账号{{ teamMembers.length + slot }}</span>
                    </button>
                  </div>
                </div>
                <div class="invite-panel">
                  <strong class="invite-panel-title">邀请新成员加入</strong>
                  <p class="invite-panel-desc">输入用户ID，点击确认添加即可享会员权益</p>
                  <div class="invite-input">
                    <img class="invite-input-icon" :src="phoneIcon" alt="" />
                    <input class="invite-input-field" ref="inviteShortIdInputRef" v-model="inviteShortId" maxlength="20"
                      placeholder="请输入用户ID" @keyup.enter="addTeamMember" />
                    <button class="invite-input-button" type="button" @click="addTeamMember">确认添加</button>
                  </div>
                  <em class="invite-panel-tip">*号码一经添加，即无法解除，请仔细确认</em>
                </div>
              </div>
            </section>
          </template>

          <section v-else class="integral-rights">
            <h2 class="member-section-title">积分<span class="member-section-title-accent">权益说明</span></h2>
            <div class="rights-grid">
              <div v-for="item in integralRights" :key="item.title" class="rights-item">
                <div class="rights-icon">
                  <img class="rights-icon-img" :src="item.icon" alt="" />
                </div>
                <div>
                  <strong class="rights-item-title">{{ item.title }}</strong>
                  <p class="rights-item-desc">{{ item.desc }}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </main>

    <ConfirmModal
      v-model="deleteDialogVisible"
      title="温馨提示"
      :content="payInfo.toast"
      width="420"
      custom-class="ConfirmModal rounded-[12px]"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="configDialog"
      @cancel="cancelDialog"
      @close="deleteDialogVisible = false"
    />

    <AvailableCouponModal
      ref="memberCouponModalRef"
      @select="handleMemberCouponSelect"
    />

    <PcMemberSuccessModal
      v-model="memberSuccessVisible"
      :member-name="memberSuccessName"
      :expire-time="memberSuccessExpireTime"
    />

    <div v-if="teamConfirmVisible" class="team-confirm-mask">
      <div class="team-confirm-wrap">
        <div class="team-confirm-dialog">
          <div class="team-confirm-header">
            <div class="team-confirm-title">
              <img class="team-confirm-title-icon" :src="teamConfirmIcon" alt="" />
              <span class="team-confirm-title-text">确认绑定子账号</span>
            </div>
            <p class="team-confirm-desc">绑定后不可解除,权益发放错误需自行承担</p>
          </div>
          <div class="team-confirm-body">
            <div class="team-confirm-info">
              <div class="team-confirm-row">
                <span>账号ID</span>
                <strong class="team-confirm-row-value">{{ teamConfirmUser?.shortId || pendingTeamShortId }}</strong>
              </div>
              <div v-if="teamConfirmUser?.number" class="team-confirm-row">
                <span>手机号</span>
                <strong class="team-confirm-row-value">{{ teamConfirmUser.number }}</strong>
              </div>
            </div>
          </div>
          <div class="team-confirm-actions">
            <button class="team-confirm-button" type="button" :disabled="teamAddLoading" @click="confirmAddTeamMember">
              {{ teamAddLoading ? '绑定中...' : '确定绑定' }}
            </button>
          </div>
        </div>
        <img :src="ic_close_white" class="team-confirm-close" @click="closeTeamConfirm">
      </div>
    </div>

    <div v-if="teamShareRuleVisible" class="team-share-rule-mask" @click.self="teamShareRuleVisible = false">
      <div class="team-share-rule-wrap">
        <div class="team-share-rule-dialog">
          <img class="team-share-rule-top-img" :src="teamShareToastIcon" alt="" />
          <div class="team-share-rule-content">
            <strong class="team-share-rule-title">团队会员说明</strong>
            <div class="team-share-rule-list">
              <div class="team-share-rule-item">
                <span class="team-share-rule-index">1</span>
                <p class="team-share-rule-text">
                  团队会员，拥有该权益后，添加子账号后，
                  <em class="team-share-rule-highlight">子账号获得【月度轻享会员】权益，有效期【1个月】</em>
                  ，与主账号的权益量独立的，互不影响。
                </p>
              </div>
              <div class="team-share-rule-item">
                <span class="team-share-rule-index">2</span>
                <p class="team-share-rule-text">团队会员绑定添加子账号后则不可修改。</p>
              </div>
              <div class="team-share-rule-item">
                <span class="team-share-rule-index">3</span>
                <p class="team-share-rule-text">
                  当主账号
                  <em class="team-share-rule-highlight">【5年会员】</em>
                  到期未续费，会员权益失效后，子账号会员权益也同时失效。
                </p>
              </div>
              <div class="team-share-rule-item">
                <span class="team-share-rule-index">4</span>
                <p class="team-share-rule-text">子账号会员到期后，则子账号会员权益失效。</p>
              </div>
              <div class="team-share-rule-item">
                <span class="team-share-rule-index">5</span>
                <p class="team-share-rule-text">
                  例如：添加了另外1个一点PPT子账号，子账号享受
                  <em class="team-share-rule-highlight">【月度轻享会员】</em>
                  的会员时长+会员权益，主账号依然享受
                  <em class="team-share-rule-highlight">5年会员</em>
                  的时长+会员权益，互不影响。
                </p>
              </div>
            </div>
          </div>
        </div>
        <img :src="ic_close_white" class="team-share-rule-close" alt="关闭" @click="teamShareRuleVisible = false">
      </div>
    </div>
    <PcActivityModal
      location="MEMBER"
      defer-login-until-finished
      @finished="handlePcActivityFinished"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import ConfirmModal from '@/components/YiDian/ConfirmModal/index.vue'
import PcActivityModal from '@/components/YiDian/PcActivityModal/index.vue'
import { ElMessage } from 'element-plus'
import { ArrowRight } from '@element-plus/icons-vue'
import * as UserApi from '@/api/user'
import { getAvailableCoupon } from '@/api/coupon'
import * as MemberApi from '@/api/member'
import * as TemplateApi from '@/api/template'
import { useUserStore } from '@/store/user'
import { useRoute, useRouter } from 'vue-router'
import useExport from '@/hooks/useExport'
import dayjs from 'dayjs'
import { reportEvent as reportAnalyticsEvent } from '@/utils/auth'
import { COUPON_CLAIM_SUCCESS_EVENT } from '@/utils/couponEvents.js'
import { buildRightsCompare } from './utils/memberRights'
import wechat from '@/assets/images/wechat.png'
import zfb from '@/assets/images/zfb.png'
import svipBadge from '@/assets/images/member/member_svip_icon.png'
import vipBadge from '@/assets/images/interDetail/member_vip_icon.png'
import vipIcon from '@/assets/images/member/vip.png'
import addIcon from '@/assets/images/member/member_add.png'
import giftIcon from '@/assets/images/member/member_suo.png'
import teamCrown from '@/assets/images/member/member_tag_icon1.png'
import phoneIcon from '@/assets/images/member/member_phone_icon1.png'
import integralRightIcon from '@/assets/images/member/member_points_icon2.png'
import integralSceneIcon from '@/assets/images/member/member_points_icon1.png'
import trueIcon from '@/assets/images/member/icon_true.png'
import falseIcon from '@/assets/images/member/icon_false.png'
import noVipIcon from '@/assets/images/member/icon_no_vip.png'
import memberVipIcon from '@/assets/images/member/icon_vip.png'
import logo_1dian from '@/assets/images/member/logo_1dian.png'
import ic_close_white from '@/assets/images/library/ic_close_white@2x.png'
import teamConfirmIcon from '@/assets/images/member/member_huangguang.png'
import teamShareToastIcon from '@/assets/images/member/icon_toast_web.png'
import AvailableCouponModal from '@/components/YiDian/AvailableCouponModal/index.vue'
import PcMemberSuccessModal from '@/components/YiDian/PcMemberSuccessModal/index.vue'
defineOptions({ name: 'MemberContent' })

const props = defineProps({
  mode: {
    type: String,
    default: 'page'
  },
  memberType: {
    type: String,
    default: ''
  },
  selectDuration: {
    type: [Boolean, String],
    default: false
  },
  source: {
    type: String,
    default: ''
  }
})

const router = useRouter()
const route = useRoute()
const memberSource = computed(() => props.source || route.query.source || '')
const reportEvent = (event, params = {}) => reportAnalyticsEvent(event, {
  ...params,
  ...(memberSource.value ? { source: memberSource.value } : {})
})
const userStore = useUserStore()
const userInfo = computed(() => userStore.getUser)
const { exportPPTX, exporting } = useExport()

const activeName = ref('Member')
const catalogData = ref({})
const activeCards = ref(null)
const payNumber = ref('')
const payTitle = ref('')
const memberData = ref([])
const integralData = ref([])
const durationData = ref([])
const payInfo = ref({})
const activePayment = ref('WECHAT')
const payQrCode = ref('')
const iframeContainer = ref(null)
const isAlipayForm = ref(false)
const pollingInterval = ref(null)
const isLoadingPayQr = ref(false)
const deleteDialogVisible = ref(false)
const paymentCardRef = ref(null)
const paymentCardRef2 = ref(null)
const durationCardRef = ref(null)
const memberTabsRef = ref(null)
const memberCouponModalRef = ref(null)
const selectedAvailableCoupon = ref(null)
const availableCouponList = ref([])
const latestCouponRequestKey = ref(0)
const refreshCouponsAfterDialogCharge = ref(false)
const teamSubListRef = ref(null)
const inviteShortIdInputRef = ref(null)
const isRightsExpanded = ref(false)
const inviteShortId = ref('')
const memberEquity = ref({})
const teamMemberList = ref([])
const pptTemplateDownloading = ref(false)
const teamConfirmVisible = ref(false)
const teamConfirmUser = ref(null)
const teamConfirmLoading = ref(false)
const teamAddLoading = ref(false)
const pendingTeamShortId = ref('')
const isTeamSubListDragging = ref(false)
const teamShareRuleVisible = ref(false)
const isCatalogRefreshing = ref(false)
const lastCatalogFetchTime = ref(0)
const animatedPlanPrices = ref({})
const animatedPlanPriceDone = ref(false)
const pcActivityFinished = ref(false)
const memberSuccessVisible = ref(false)
const memberSuccessName = ref('会员')
const memberSuccessExpireTime = ref('-')

let countdownTimer = null
let limitedTimeCountdownTimer = null
let planPriceAnimationFrame = null
let planPriceAnimationDelayTimer = null
let startX = 0
let scrollLeft = 0
let isDragging = false
let dragContainer = null
let teamDragStartX = 0
let teamDragScrollLeft = 0
let teamDragMoved = false

const countdown = ref({
  hours: 0,
  minutes: 0,
  seconds: 0,
  milliseconds: 0
})

const PRICE_TYPE_FIRST_PURCHASE = 'FIRST_PURCHASE'
const PRICE_TYPE_LIMITED_TIME = 'LIMITED_TIME'
const CATALOG_FETCH_CACHE_MS = 3000
const PLAN_PRICE_ANIMATION_DELAY = 1000
const PLAN_PRICE_ANIMATION_DURATION = 1800
const limitedTimeCountdownBase = ref(Date.now())
const limitedTimeCountdownNow = ref(Date.now())

const limitedGifts = [
  { logo: logo_1dian, title: '公文宝会员', desc: '7天会员' }
]

const integralRights = [

  { icon: integralRightIcon, title: '积分权益', desc: '购买获得的积分，用于AI创作、PPT出等多项功能。' },
  { icon: integralSceneIcon, title: '积分使用场景', desc: '海量模板下载、AI文档生成、格式转换等多种场景。' },
]

const rightsCatalogs = computed(() => memberEquity.value?.vipCatalogList || [])

const rightsColumns = computed(() => {
  return rightsCatalogs.value.map((item, index) => ({
    key: item.type || item.code || `vip-${index}`,
    name: item.name || '会员',
    icon: item.type === 'NORMAL' ? noVipIcon : memberVipIcon,
    catalog: item
  }))
})

const currentRightsColumnKey = computed(() => {
  const vip = userInfo.value?.vip || {}
  if (!vip.vip) return ''
  const candidates = [vip.vipType, vip.type, vip.catalogCode, vip.code, vip.name].filter(Boolean).map(String)
  const matched = rightsColumns.value.find((column) => {
    const catalog = column.catalog || {}
    return [column.key, column.name, catalog.type, catalog.code, catalog.name].filter(Boolean).some((value) => candidates.includes(String(value)))
  })
  return matched?.key || ''
})

const rightsCompare = computed(() => {
  return buildRightsCompare(rightsColumns.value)
})

const visibleRightsCompare = computed(() => {
  return isRightsExpanded.value ? rightsCompare.value : rightsCompare.value.slice(0, 5)
})

const pptLimitedTemplateLocked = computed(() => memberEquity.value?.pptLimitedTemplateLocked !== false)

const pptTemplates = computed(() => {
  const templates = memberEquity.value?.pptTemplates || []
  return templates.map((item) => ({
    ...item,
    id: item.id,
    title: item.name || 'PPT模板',
    desc: `${item.pageCount || 0}页`,
    cover: item.cover || ''
  }))
})

const canScrollPptTemplates = computed(() => pptTemplates.value.length > 4)

const hasThirdPartySharedVipPermission = computed(() => memberEquity.value?.thirdPartySharedVipLocked === false)

const teamShareConfig = computed(() => memberEquity.value?.teamShareConfig || {})

const hasTeamSharePermission = computed(() => Object.keys(teamShareConfig.value).length > 0)

const maxTeamMembers = computed(() => {
  return teamShareConfig.value.subAccountCount || 3
})

const teamMembers = computed(() => {
  return teamMemberList.value
})

const relatedTeamVipName = computed(() => {
  return teamShareConfig.value.relatedVipCatalogTypeName || '月度轻享会员'
})

const emptyTeamSlots = computed(() => {
  return Array.from({ length: Math.max(maxTeamMembers.value - teamMembers.value.length, 0) }, (_, index) => index + 1)
})

const currentCatalogPayPrice = computed(() => {
  if (!payInfo.value || !payInfo.value.originalPrice) return 0
  if (activeName.value === 'Member') return payInfo.value.payPrice || 0
  return userInfo.value?.vip?.vip ? (payInfo.value.vipPayPrice || payInfo.value.payPrice || 0) : (payInfo.value.payPrice || 0)
})

const hasCouponUserId = (coupon) => {
  const userCouponId = coupon?.userCouponId
  return userCouponId !== undefined && userCouponId !== null && userCouponId !== ''
}

const isActualAvailableCoupon = (coupon) => {
  return coupon?.canUse !== false && hasCouponUserId(coupon)
}

const sortCouponsByAvailability = (list = []) => {
  return [...list].sort((prev, next) => Number(!isActualAvailableCoupon(prev)) - Number(!isActualAvailableCoupon(next)))
}

const formatPrice = (value) => {
  const number = Number(value || 0)
  if (!Number.isFinite(number)) return '0'
  return Number.isInteger(number) ? String(number) : number.toFixed(2)
}

const getCatalogPayablePrice = (item = payInfo.value) => {
  const payablePrice = Number(item?.payablePrice)
  if (Number.isFinite(payablePrice)) return payablePrice
  return getBaseCatalogPayablePrice(item)
}

const getBaseCatalogPayablePrice = (item = payInfo.value) => {
  if (activeName.value === 'Member') return Number(item?.payPrice || 0)
  return Number(userInfo.value?.vip?.vip ? (item?.vipPayPrice || item?.payPrice || 0) : (item?.payPrice || 0))
}

const syncPayablePrice = (price) => {
  if (price === undefined || price === null || price === '') return
  payInfo.value = {
    ...payInfo.value,
    payablePrice: price
  }
}

const actualPayPrice = computed(() => getCatalogPayablePrice())

const hasMemberPlans = computed(() => memberData.value.length > 0)

const hasIntegralPlans = computed(() => integralData.value.length > 0)

const hasDurationPlans = computed(() => durationData.value.length > 0)

const hasFuelPlans = computed(() => hasIntegralPlans.value || hasDurationPlans.value)

const visibleTabCount = computed(() => Number(hasMemberPlans.value) + Number(hasFuelPlans.value))

const fuelTabTitle = computed(() => hasIntegralPlans.value ? '加油包' : '会议加油包')

const fuelTabDesc = computed(() => {
  return hasIntegralPlans.value
    ? '适合积分不足时快速补充，按需充值积分'
    : '适合积分不足时快速补充，按需充值积分'
})

const discountAmount = computed(() => {
  if (!payInfo.value || !payInfo.value.originalPrice) return 0
  const discount = payInfo.value.originalPrice - currentCatalogPayPrice.value
  return Math.max(0, Math.floor(discount * 100) / 100)
})

const couponDiscountAmount = computed(() => {
  if (!isActualAvailableCoupon(selectedAvailableCoupon.value)) return 0
  const amount = Number(selectedAvailableCoupon.value?.discountAmount || 0)
  return Math.max(0, Math.floor(amount * 100) / 100)
})

const couponDiscountAmountText = computed(() => formatPrice(couponDiscountAmount.value))

const availableCouponCount = computed(() => availableCouponList.value.filter(isActualAvailableCoupon).length)

const couponCardValue = computed(() => {
  if (couponDiscountAmount.value > 0) return `-￥${couponDiscountAmountText.value}`
  if (availableCouponCount.value > 0) return `${availableCouponCount.value}张可用`
  return '选择'
})

const selectedAvailableCouponId = computed(() => isActualAvailableCoupon(selectedAvailableCoupon.value) ? selectedAvailableCoupon.value.userCouponId : '')

const resetAvailableCoupons = () => {
  latestCouponRequestKey.value += 1
  availableCouponList.value = []
}

const payPolicyUrl = computed(() => {
  return window.location.origin + router.resolve({ path: '/pay-policy' }).href
})

const integralRuleUrl = computed(() => {
  return window.location.origin + router.resolve({ path: '/integral-rule' }).href
})

const normalizeMemberType = (type) => {
  if (type === 'Integral' || type === 'Recharge' || type === 'Time') return 'Integral'
  return 'Member'
}

const getAvailableTargetType = (type) => {
  const targetType = normalizeMemberType(type)
  if (targetType === 'Member' && hasMemberPlans.value) return 'Member'
  if (targetType === 'Integral' && hasFuelPlans.value) return 'Integral'
  if (hasMemberPlans.value) return 'Member'
  if (hasFuelPlans.value) return 'Integral'
  return ''
}

const isTruthy = (value) => {
  return value === true || value === 'true' || value === '1'
}

const currentMemberType = computed(() => {
  return props.memberType || route.query.memberType || route.query.type || 'Member'
})

const currentSelectDuration = computed(() => {
  return props.selectDuration !== false && props.selectDuration !== ''
    ? isTruthy(props.selectDuration)
    : isTruthy(route.query.selectDuration)
})

const updateCountdown = () => {
  const now = new Date().getTime()
  const cycleDuration = 72 * 60 * 60 * 1000
  const elapsed = now % cycleDuration
  const remaining = cycleDuration - elapsed
  countdown.value = {
    hours: Math.floor(remaining / (1000 * 60 * 60)),
    minutes: Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((remaining % (1000 * 60)) / 1000),
    milliseconds: Math.floor((remaining % 1000) / 10)
  }
}

const startCountdown = () => {
  updateCountdown()
  countdownTimer = setInterval(updateCountdown, 10)
}

const stopCountdown = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
}

const formatLimitedTime = (seconds) => {
  const total = Math.max(0, Number(seconds) || 0)
  const days = Math.floor(total / 86400)
  const hours = String(Math.floor((total % 86400) / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, '0')
  const restSeconds = String(total % 60).padStart(2, '0')
  if (days > 0) return `${days}天 ${hours}:${minutes}:${restSeconds}`
  return `${hours}:${minutes}:${restSeconds}`
}

const getLimitedTimeRemainingSeconds = (item) => {
  const elapsedSeconds = Math.floor((limitedTimeCountdownNow.value - limitedTimeCountdownBase.value) / 1000)
  return Math.max(0, Number(item?.limitedTimeRemainingSeconds || 0) - elapsedSeconds)
}

const isLimitedTimePrice = (item) => item?.priceType === PRICE_TYPE_LIMITED_TIME

const isFirstPurchasePrice = (item) => item?.priceType === PRICE_TYPE_FIRST_PURCHASE || item?.isFirstPurchase

const shouldAnimatePlanPrice = (item) => isFirstPurchasePrice(item) || isLimitedTimePrice(item)

const parsePriceNumber = (value) => {
  const matched = String(value || '').match(/[\d.]+/)
  return matched ? Number(matched[0]) : 0
}

const getPlanPrice = (item, type = activeName.value) => {
  if (type === 'Member') return item?.payPrice || 0
  return userInfo.value?.vip?.vip ? (item?.vipPayPrice || item?.payPrice || 0) : (item?.payPrice || 0)
}

const getPlanSubPrice = (item, type = activeName.value) => {
  if (type === 'Member') return `￥${item?.originalPrice || item?.payPrice || 0}`
  if (!userInfo.value?.vip?.vip && item?.code !== 'integral_app_2004' && item?.vipPayPrice) return `会员价￥${item.vipPayPrice}`
  return `￥${item?.originalPrice || item?.payPrice || 0}`
}

const getDisplayPlanPrice = (item, type = activeName.value) => {
  if (!shouldAnimatePlanPrice(item)) return getPlanPrice(item, type)
  return animatedPlanPrices.value[item?.code] ?? getPlanPrice(item, type)
}

const getPlanPriceAnimationItems = (list = []) => {
  return list
    .map((plan) => ({
      item: plan?.item || plan,
      type: plan?.type || activeName.value
    }))
    .filter((plan) => shouldAnimatePlanPrice(plan.item))
    .map((plan) => ({
      code: plan.item.code,
      from: parsePriceNumber(getPlanSubPrice(plan.item, plan.type)),
      to: parsePriceNumber(getPlanPrice(plan.item, plan.type))
    }))
    .filter((item) => item.code && item.from > item.to)
}

const setInitialPlanPriceAnimationValues = (items = []) => {
  items.forEach((item) => {
    animatedPlanPrices.value[item.code] = Math.floor(item.from)
  })
}

const startPlanPriceAnimation = (list = []) => {
  const items = getPlanPriceAnimationItems(list)

  if (!items.length) return

  if (planPriceAnimationFrame) cancelAnimationFrame(planPriceAnimationFrame)

  const duration = PLAN_PRICE_ANIMATION_DURATION
  const startTime = performance.now()

  const step = (now) => {
    const progress = Math.min((now - startTime) / duration, 1)
    const eased = 1 - Math.pow(1 - progress, 3)

    items.forEach((item) => {
      const value = item.from - (item.from - item.to) * eased
      animatedPlanPrices.value[item.code] = Math.floor(value)
    })

    if (progress < 1) {
      planPriceAnimationFrame = requestAnimationFrame(step)
      return
    }

    items.forEach((item) => {
      animatedPlanPrices.value[item.code] = item.to
    })
    planPriceAnimationFrame = null
  }

  planPriceAnimationFrame = requestAnimationFrame(step)
}

const startInitialPlanPriceAnimation = () => {
  if (animatedPlanPriceDone.value) return
  const list = [
    ...memberData.value.map((item) => ({ item, type: 'Member' })),
    ...integralData.value.map((item) => ({ item, type: 'Integral' })),
    ...durationData.value.map((item) => ({ item, type: 'Integral' }))
  ]
  if (!list.length) return
  const items = getPlanPriceAnimationItems(list)
  if (!items.length) return
  animatedPlanPriceDone.value = true
  setInitialPlanPriceAnimationValues(items)
  if (planPriceAnimationDelayTimer) clearTimeout(planPriceAnimationDelayTimer)
  planPriceAnimationDelayTimer = setTimeout(() => {
    startPlanPriceAnimation(list)
    planPriceAnimationDelayTimer = null
  }, PLAN_PRICE_ANIMATION_DELAY)
}

const clearPlanPriceAnimationCache = () => {
  if (planPriceAnimationDelayTimer) {
    clearTimeout(planPriceAnimationDelayTimer)
    planPriceAnimationDelayTimer = null
  }
  if (planPriceAnimationFrame) {
    cancelAnimationFrame(planPriceAnimationFrame)
    planPriceAnimationFrame = null
  }
  animatedPlanPrices.value = {}
}

const tryStartInitialPlanPriceAnimation = () => {
  if (!pcActivityFinished.value) return
  startInitialPlanPriceAnimation()
}

const handlePcActivityFinished = () => {
  pcActivityFinished.value = true
  tryStartInitialPlanPriceAnimation()
}

const parseJsonSafely = (value) => {
  if (!value) return null
  if (typeof value !== 'string') return value
  try {
    const parsed = JSON.parse(value)
    return typeof parsed === 'string' ? parseJsonSafely(parsed) : parsed
  } catch {
    return null
  }
}

const normalizePptAssetUrls = (slidesData) => {
  if (!Array.isArray(slidesData)) return []
  const replaceImageUrl = (url) => {
    if (typeof url === 'string') {
      return url.replace('https://ptos.1dppt.com', '/template')
    }
    return url
  }
  if (import.meta.env.MODE !== 'development') return slidesData
  slidesData.forEach((slide) => {
    if (slide.background?.type === 'image' && slide.background.image?.src) {
      slide.background.image.src = replaceImageUrl(slide.background.image.src)
    }
    if (Array.isArray(slide.elements)) {
      slide.elements.forEach((element) => {
        if ((element.type === 'image' || element.type === 'icon') && element.src) {
          element.src = replaceImageUrl(element.src)
        }
      })
    }
  })
  return slidesData
}

const getHotBuyText = (item) => {
  if (item?.priceType === PRICE_TYPE_FIRST_PURCHASE) return '新人特惠'
  if (isLimitedTimePrice(item)) return `限时特惠 ${formatLimitedTime(getLimitedTimeRemainingSeconds(item))}`
  if (item?.isFirstPurchase) return '新人特惠'
  return item?.tags?.find((tag) => tag.location === 'top_left')?.content || ''
}

const getCenterTag = (item) => {
  return item?.tags?.find((tag) => tag?.location === 'center')?.content || ''
}

const hasSvipTag = (item) => {
  return item?.tags?.some((tag) => tag?.content === 'SVIP')
}

const shouldUseCatalogCache = () => {
  return Date.now() - lastCatalogFetchTime.value < CATALOG_FETCH_CACHE_MS
}

const resetLimitedTimeCountdown = () => {
  limitedTimeCountdownBase.value = Date.now()
  limitedTimeCountdownNow.value = limitedTimeCountdownBase.value
}

const startLimitedTimeCountdown = () => {
  stopLimitedTimeCountdown()
  resetLimitedTimeCountdown()
  limitedTimeCountdownTimer = setInterval(() => {
    limitedTimeCountdownNow.value = Date.now()
  }, 1000)
}

const stopLimitedTimeCountdown = () => {
  if (limitedTimeCountdownTimer) {
    clearInterval(limitedTimeCountdownTimer)
    limitedTimeCountdownTimer = null
  }
}

const focusInviteInput = () => {
  inviteShortIdInputRef.value?.focus()
}

const getScrollParent = (el) => {
  const pageScroll = document.querySelector('.member-page-scroll')
  if (pageScroll instanceof HTMLElement) return pageScroll

  let parent = el?.parentElement
  while (parent && parent !== document.body && parent !== document.documentElement) {
    const style = window.getComputedStyle(parent)
    const overflowY = style.overflowY
    if ((overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && parent.scrollHeight > parent.clientHeight + 1) {
      return parent
    }
    parent = parent.parentElement
  }
  return document.scrollingElement || document.documentElement
}

const resolveMemberPlansTarget = () => {
  const tabsEl = memberTabsRef.value?.$el || memberTabsRef.value
  if (tabsEl instanceof HTMLElement) return tabsEl
  return document.querySelector('.member-tabs-container') || document.querySelector('.plans-panel') || document.querySelector('.content-card-title')
}

const scrollToMemberPlans = (target) => {
  const headerOffset = 16
  const scrollParent = getScrollParent(target)

  if (scrollParent === document.scrollingElement || scrollParent === document.documentElement || scrollParent === document.body) {
    const top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - 70)
    window.scrollTo({ top, behavior: 'smooth' })
    document.documentElement.scrollTo({ top, behavior: 'smooth' })
    document.body.scrollTo({ top, behavior: 'smooth' })
    return
  }

  const parentRect = scrollParent.getBoundingClientRect()
  const targetRect = target.getBoundingClientRect()
  const top = Math.max(0, scrollParent.scrollTop + (targetRect.top - parentRect.top) - headerOffset)
  scrollParent.scrollTo({ top, behavior: 'smooth' })
}

const scrollMemberPageTop = () => {
  if (hasMemberPlans.value && activeName.value !== 'Member') {
    activeName.value = 'Member'
  }

  nextTick(() => {
    requestAnimationFrame(() => {
      const target = resolveMemberPlansTarget()
      if (target) {
        scrollToMemberPlans(target)
        return
      }

      const pageScroll = document.querySelector('.member-page-scroll')
      if (pageScroll instanceof HTMLElement) {
        pageScroll.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }

      window.scrollTo({ top: 0, behavior: 'smooth' })
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })
      document.body.scrollTo({ top: 0, behavior: 'smooth' })
    })
  })
}

const handleNoMemberPermission = () => {
  ElMessage.error({
    message: '您当前的身份暂时无法享受该权益，升级会员即可解锁更多权益！',
    offset: window.innerHeight / 2 - 40
  })
  scrollMemberPageTop()
}

const getPptTemplateStyleJson = (payload) => payload?.styleJson || payload?.ppt?.styleJson || payload?.data?.styleJson || ''

const getPptTemplateTitle = (payload, fallbackTitle) => {
  return payload?.title || payload?.name || payload?.ppt?.title || payload?.data?.title || payload?.data?.name || fallbackTitle || 'PPT模板'
}

const resolvePptTemplateSlides = (styleJson) => {
  const pptData = parseJsonSafely(styleJson)
  const rawSlides = Array.isArray(pptData?.slides) ? pptData.slides : (Array.isArray(pptData) ? pptData : [])
  return normalizePptAssetUrls(rawSlides)
}

const handlePptTemplateClick = async (item) => {
  if (pptLimitedTemplateLocked.value) {
    handleNoMemberPermission()
    return
  }

  if (pptTemplateDownloading.value || exporting.value) return

  if (!item?.id) {
    ElMessage.warning({
      message: '模板数据异常，请稍后重试',
      offset: 60
    })
    return
  }

  pptTemplateDownloading.value = true

  try {
    const res = await TemplateApi.getPPTemplateDetail({
      params: {
        id: item.id
      }
    })

    if (res?.code !== 'SUCCESS' || !res?.data) {
      throw new Error(res?.msg || '获取模板详情失败')
    }

    const styleJson = getPptTemplateStyleJson(res.data)
    if (!styleJson) {
      throw new Error('当前模板暂无可下载内容')
    }

    const slidesData = resolvePptTemplateSlides(styleJson)
    if (!slidesData.length) {
      throw new Error('当前模板暂无可下载内容')
    }

    await exportPPTX(slidesData, true, true, getPptTemplateTitle(res.data, item.title))
  } catch (error) {
    console.error('下载PPT模板失败:', error)
    ElMessage.warning({
      message: error?.message || '下载失败，请稍后重试',
      offset: 60
    })
  } finally {
    pptTemplateDownloading.value = false
  }
}

const handleLimitedGiftClick = () => {
  if (!hasThirdPartySharedVipPermission.value) {
    handleNoMemberPermission()
    return;
  }

  ElMessage.success({
    message: '恭喜您当前可以领取该项会员权益，请联系客服兑换。',
    offset: window.innerHeight / 2 - 40
  })
  // 恭喜您当前可以领取该项会员权益，请联系客服兑换

}

const handleTeamSubListMouseDown = (event) => {
  const container = teamSubListRef.value?.$el || teamSubListRef.value
  if (!container || container.scrollWidth <= container.clientWidth) return

  isTeamSubListDragging.value = true
  teamDragMoved = false
  teamDragStartX = event.pageX - container.offsetLeft
  teamDragScrollLeft = container.scrollLeft
  window.addEventListener('mousemove', handleTeamSubListMouseMove)
  window.addEventListener('mouseup', handleTeamSubListMouseUp)
  document.body.style.userSelect = 'none'
}

const handleTeamSubListMouseMove = (event) => {
  if (!isTeamSubListDragging.value) return
  const container = teamSubListRef.value?.$el || teamSubListRef.value
  if (!container) return

  const x = event.pageX - container.offsetLeft
  const walk = x - teamDragStartX
  if (Math.abs(walk) > 4) teamDragMoved = true
  if (teamDragMoved) event.preventDefault()
  container.scrollLeft = teamDragScrollLeft - walk
}

const handleTeamSubListMouseUp = () => {
  isTeamSubListDragging.value = false
  window.removeEventListener('mousemove', handleTeamSubListMouseMove)
  window.removeEventListener('mouseup', handleTeamSubListMouseUp)
  document.body.style.userSelect = ''
  window.setTimeout(() => {
    teamDragMoved = false
  }, 0)
}

const handleTeamAddClick = () => {
  if (teamDragMoved) return

  if (!hasTeamSharePermission.value) {
    handleNoMemberPermission()
    return
  }
  focusInviteInput()
}

const closeTeamConfirm = () => {
  if (teamAddLoading.value) return
  teamConfirmVisible.value = false
  teamConfirmUser.value = null
  pendingTeamShortId.value = ''
}

const addTeamMember = async () => {
  const shortId = inviteShortId.value.trim()

  if (!hasTeamSharePermission.value) {
    handleNoMemberPermission()
    return
  }

  if (!shortId) {
    ElMessage.warning({
      message: '请输入用户ID',
      offset: window.innerHeight / 2 - 40
    })
    return
  }

  if (teamMembers.value.some((member) => String(member.shortId) === shortId)) {
    ElMessage.warning({
      message: '该用户已添加',
      offset: window.innerHeight / 2 - 40
    })
    return
  }

  if (teamMembers.value.length >= maxTeamMembers.value) {
    ElMessage.warning({
      message: '账号已满',
      offset: window.innerHeight / 2 - 40
    })
    return
  }

  if (teamConfirmLoading.value) return
  teamConfirmLoading.value = true
  pendingTeamShortId.value = shortId
  teamConfirmUser.value = { shortId }

  try {
    await confirmAddTeamMember()
  } finally {
    teamConfirmLoading.value = false
  }
}

const confirmAddTeamMember = async () => {
  const shortId = pendingTeamShortId.value
  if (!shortId || teamAddLoading.value) return

  teamAddLoading.value = true
  const addedUser = teamConfirmUser.value

  try {
    const res = await MemberApi.setSubAccount({
      params: {
        shortId
      }
    })

    if (res.code === 'SUCCESS') {
      ElMessage({
        type: 'success',
        message: '添加成功',
        offset: window.innerHeight / 2 - 40
      })
      await getMemberEquity({ showError: false })
      ensureAddedTeamMemberVisible(addedUser, shortId)
      teamConfirmUser.value = null
      pendingTeamShortId.value = ''
      inviteShortId.value = ''
      teamConfirmVisible.value = false
    } else {
      throw new Error(res.msg || '添加失败')
    }
  } catch (error) {
    ElMessage.error({
      message: error?.message || '添加失败',
      offset: window.innerHeight / 2 - 40
    })
  } finally {
    teamAddLoading.value = false
  }
}

const normalizeTeamMember = (user, fallbackShortId) => ({
  ...user,
  avatar: user?.avatar || user?.head || '',
  name: user?.name || user?.nickname || '子账号',
  shortId: user?.shortId || fallbackShortId
})

const syncTeamMemberList = (teamConfig = {}) => {
  const config = teamConfig || {}
  const sharedUsers = Array.isArray(config.sharedUsers) ? config.sharedUsers : []
  teamMemberList.value = sharedUsers.map((item) => normalizeTeamMember(item, item.shortId))
}

const ensureAddedTeamMemberVisible = (user, fallbackShortId) => {
  const shortId = String(user?.shortId || fallbackShortId || '')
  if (!shortId || teamMembers.value.some((member) => String(member.shortId) === shortId)) return

  const teamConfig = memberEquity.value?.teamShareConfig || {}
  const sharedUsers = Array.isArray(teamConfig.sharedUsers) ? teamConfig.sharedUsers : []
  const nextMember = normalizeTeamMember(user, shortId)
  teamMemberList.value = [
    ...teamMemberList.value,
    nextMember
  ]
  memberEquity.value = {
    ...memberEquity.value,
    teamShareConfig: {
      ...teamConfig,
      sharedUsers: [
        ...sharedUsers,
        nextMember
      ]
    }
  }
}

const getMemberEquity = async ({ showError = true } = {}) => {
  try {
    const res = await MemberApi.getEquity({})
    if (res.code === 'SUCCESS') {
      memberEquity.value = res.data || {}
      syncTeamMemberList(memberEquity.value?.teamShareConfig)
      return true
    } else {
      if (showError) ElMessage.error({
        message: res.msg,
        offset: window.innerHeight / 2 - 40
      })
      return false
    }
  } catch (error) {
    if (showError) {
      ElMessage.error({
        message: error?.message || '会员权益刷新失败',
        offset: window.innerHeight / 2 - 40
      })
    }
    return false
  }
}

const getchargeCatalog = (type = currentMemberType.value, selectDuration = currentSelectDuration.value) => {
  if (isCatalogRefreshing.value) return
  isCatalogRefreshing.value = true

  UserApi.chargeCatalog({}).then((res) => {
    if (res.code === 'SUCCESS') {
      clearPlanPriceAnimationCache()
      catalogData.value = res.data || {}
      memberData.value = catalogData.value.vipCatalogs || []
      integralData.value = catalogData.value.integralCatalogs || []
      durationData.value = catalogData.value.timeCatalogs || []
      lastCatalogFetchTime.value = Date.now()
      resetLimitedTimeCountdown()
      tryStartInitialPlanPriceAnimation()

      applyCatalogTab(type, selectDuration)
    } else {
      ElMessage.error({
        message: res.msg,
        offset: window.innerHeight / 2 - 40
      })
    }
  }).finally(() => {
    isCatalogRefreshing.value = false
  })
}

const getDefaultSelectedCatalog = (list = []) => {
  return list.find((item) => item?.defaultSelected === 1 || item?.defaultSelected === '1') || list[0]
}

const getDefaultFuelCatalog = (selectDuration = false) => {
  if (selectDuration && hasDurationPlans.value) return getDefaultSelectedCatalog(durationData.value)
  if (hasIntegralPlans.value) return getDefaultSelectedCatalog(integralData.value)
  if (hasDurationPlans.value) return getDefaultSelectedCatalog(durationData.value)
  return null
}

const fetchAvailableCoupons = async () => {
  if (!activeCards.value) {
    resetAvailableCoupons()
    return
  }

  const requestKey = latestCouponRequestKey.value + 1
  latestCouponRequestKey.value = requestKey

  try {
    const res = await getAvailableCoupon({ catalogCode: activeCards.value })
    if (requestKey !== latestCouponRequestKey.value) return

    availableCouponList.value = res.code === 'SUCCESS' && Array.isArray(res.data)
      ? sortCouponsByAvailability(res.data)
      : []
  } catch {
    if (requestKey === latestCouponRequestKey.value) {
      availableCouponList.value = []
    }
  }
}

const applySelectedCatalog = (item, { refreshCouponsAfterCharge = false } = {}) => {
  if (!item) return false
  selectedAvailableCoupon.value = null
  resetAvailableCoupons()
  activeCards.value = item.code
  payNumber.value = activeName.value === 'Member'
    ? item.payPrice
    : (userInfo.value?.vip?.vip ? (item.vipPayPrice || item.payPrice) : item.payPrice)
  payTitle.value = item.name
  payInfo.value = item
  syncPayablePrice(item.payablePrice ?? getBaseCatalogPayablePrice(item))
  if (!refreshCouponsAfterCharge) fetchAvailableCoupons()
  return true
}

const applyCatalogTab = (type, selectDuration = false) => {
  const targetType = getAvailableTargetType(type)
  if (!targetType) {
    activeCards.value = null
    payNumber.value = ''
    payTitle.value = ''
    payInfo.value = {}
    resetAvailableCoupons()
    return
  }

  activeName.value = targetType
  const refreshCouponsAfterCharge = isActualAvailableCoupon(selectedAvailableCoupon.value)

  if (targetType === 'Member') {
    if (!applySelectedCatalog(getDefaultSelectedCatalog(memberData.value), { refreshCouponsAfterCharge })) return
  } else {
    if (!applySelectedCatalog(getDefaultFuelCatalog(selectDuration), { refreshCouponsAfterCharge })) return
  }

  scrollToLeft()
  getCharge({ refreshCouponsAfterCharge })
}

const handleTabClick = (type, selectDuration = false) => {
  const targetType = getAvailableTargetType(type)
  if (isCatalogRefreshing.value) return
  if (shouldUseCatalogCache()) {
    applyCatalogTab(targetType, selectDuration)
    return
  }
  getchargeCatalog(targetType, selectDuration)
}

const handleBeforeTabLeave = () => {
  return !isCatalogRefreshing.value
}

const handleClick = () => {
  scrollToLeft()
}

const handleCardClick = (item, event) => {
  scrollPlanCardToCenter(event)
  const refreshCouponsAfterCharge = isActualAvailableCoupon(selectedAvailableCoupon.value)
  selectedAvailableCoupon.value = null
  resetAvailableCoupons()
  payInfo.value = item
  syncPayablePrice(item.payablePrice ?? getBaseCatalogPayablePrice(item))
  payTitle.value = item.name
  activeCards.value = item.code
  payNumber.value = activeName.value === 'Member'
    ? item.payPrice
    : (userInfo.value?.vip?.vip ? (item.vipPayPrice || item.payPrice) : item.payPrice)
  if (!refreshCouponsAfterCharge) fetchAvailableCoupons()

  reportEvent('app_clicks', {
    ck_module: '会员页_套餐',
    keyword: item.name
  })

  if (!item.toast) {
    refreshCouponsAfterDialogCharge.value = false
    getCharge({ refreshCouponsAfterCharge })
  } else {
    refreshCouponsAfterDialogCharge.value = refreshCouponsAfterCharge
    deleteDialogVisible.value = true
    reportEvent('page_view', {
      page_name: '购买1500积分弹窗'
    })
  }
}

const changPay = (value) => {
  activePayment.value = value
  getCharge()
}

const getCharge = ({ refreshCouponsAfterCharge = false } = {}) => {
  if (!activeCards.value) return
  payQrCode.value = ''
  isLoadingPayQr.value = true
  const useCoupon = isActualAvailableCoupon(selectedAvailableCoupon.value)
  const params = {
    catalogCode: activeCards.value,
    payMethod: activePayment.value,
    returnUrl: window.location.origin,
    useCoupon
  }
  if (useCoupon) {
    params.userCouponId = selectedAvailableCoupon.value.userCouponId
  }

  reportEvent('pay_create', {
    pay_title: payTitle.value
  })

  return UserApi.chargeOrder({ params }).then((res) => {
    if (res.code === 'SUCCESS') {
      syncPayablePrice(res.data?.payablePrice)
      payQrCode.value = res.data.payUrl
      isAlipayForm.value = activePayment.value === 'ALIPAY'
      startPolling(res.data.orderNo)
    } else {
      ElMessage.error({
        message: res.msg,
        offset: window.innerHeight / 2 - 40
      })
    }
  }).finally(() => {
    if (refreshCouponsAfterCharge) fetchAvailableCoupons()
    setTimeout(() => {
      isLoadingPayQr.value = false
    }, 600)
  })
}

const showMemberSuccessModal = (refreshedUser) => {
  const vip = refreshedUser?.vip || userInfo.value?.vip || {}
  memberSuccessName.value = vip.vipType || vip.name || payTitle.value || '会员'
  memberSuccessExpireTime.value = vip.expireTime || '-'
  memberSuccessVisible.value = true
}

const startPolling = (orderNo) => {
  stopPolling()
  pollingInterval.value = setInterval(() => {
    UserApi.checkCharge({ params: { orderNo } }).then((res) => {
      if (res.code === 'SUCCESS') {
        if (res.data.payed) {
          ElMessage.success({
            message: '支付成功！',
            offset: window.innerHeight / 2 - 40
          })
          reportEvent('pay_order', {
            pay_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            pay_amount: actualPayPrice.value,
            pay_title: payTitle.value,
            pay_way: activePayment.value === 'WECHAT' ? '微信' : '支付宝',
            if_success: '是'
          })
          const isMemberPurchase = activeName.value === 'Member'
          getUser().then((refreshedUser) => {
            if (!isMemberPurchase) return
            showMemberSuccessModal(refreshedUser)
          }).catch(() => {
            if (isMemberPurchase) showMemberSuccessModal()
          })
          window.referBotList?.()
          window.referData?.()
          stopPolling()
          getchargeCatalog()
          getMemberEquity()
        }
      } else {
        ElMessage.error({
          message: res.msg,
          offset: window.innerHeight / 2 - 40
        })
        reportEvent('pay_order', {
          pay_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          pay_amount: actualPayPrice.value,
          pay_title: payTitle.value,
          pay_way: activePayment.value === 'WECHAT' ? '微信' : '支付宝',
          if_success: '否',
          fail_reason: res.msg
        })
        stopPolling()
      }
    })
  }, 3000)
}

const stopPolling = () => {
  if (pollingInterval.value) {
    clearInterval(pollingInterval.value)
    pollingInterval.value = null
  }
}

const getUser = () => {
  return UserApi.getUserInfo({ params: {} }).then((res) => {
    if (res.code === 'SUCCESS') {
      setTimeout(() => {
        userStore.setUserInfo(res.data)
      }, 3000)
      return res.data
    }
    return null
  })
}

const handleMouseDown = (e) => {
  const container = e.currentTarget
  if (!container) return
  dragContainer = container
  isDragging = true
  startX = e.pageX - container.offsetLeft
  scrollLeft = container.scrollLeft
  window.addEventListener('mousemove', handleMouseMove)
  window.addEventListener('mouseup', handleMouseUp)
  document.body.style.userSelect = 'none'
}

const handleMouseMove = (e) => {
  if (!isDragging) return
  const container = dragContainer
  if (!container) return
  const x = e.pageX - container.offsetLeft
  const walk = (x - startX) * 2
  container.scrollLeft = scrollLeft - walk
}

const handleMouseUp = () => {
  isDragging = false
  dragContainer = null
  window.removeEventListener('mousemove', handleMouseMove)
  window.removeEventListener('mouseup', handleMouseUp)
  document.body.style.userSelect = ''
}

const configDialog = () => {
  deleteDialogVisible.value = false
  const refreshCouponsAfterCharge = refreshCouponsAfterDialogCharge.value
  refreshCouponsAfterDialogCharge.value = false
  getCharge({ refreshCouponsAfterCharge })
  reportEvent('app_clicks', {
    ck_module: '1500积分弹窗_确定购买'
  })
}

const cancelDialog = () => {
  deleteDialogVisible.value = false
  const refreshCouponsAfterCharge = refreshCouponsAfterDialogCharge.value
  refreshCouponsAfterDialogCharge.value = false
  getCharge({ refreshCouponsAfterCharge })
  reportEvent('app_clicks', {
    ck_module: '1500积分弹窗_取消'
  })
}

const refreshMemberPageAfterCouponClaim = async () => {
  await fetchAvailableCoupons()
  if (isActualAvailableCoupon(selectedAvailableCoupon.value)) {
    getCharge()
  }
}

const openMemberCouponModal = () => {
  if (!activeCards.value) return
  memberCouponModalRef.value?.open?.({
    catalogCode: activeCards.value,
    selectedCouponId: selectedAvailableCouponId.value
  })
  reportEvent('app_clicks', {
    ck_module: '会员页_优惠券'
  })
}

const handleMemberCouponSelect = (coupon) => {
  selectedAvailableCoupon.value = isActualAvailableCoupon(coupon) ? coupon : null
  if (selectedAvailableCoupon.value) {
    syncPayablePrice(selectedAvailableCoupon.value.payablePrice ?? selectedAvailableCoupon.value.payableAmount)
  } else {
    syncPayablePrice(getBaseCatalogPayablePrice())
  }
  getCharge()
  reportEvent('app_clicks', {
    ck_module: '会员页_优惠券_确认',
    ck_value: coupon?.name || '不使用优惠券'
  })
}

const scrollToLeft = () => {
  nextTick(() => {
    setTimeout(() => {
      if (paymentCardRef2.value) paymentCardRef2.value.scrollLeft = 0
      if (paymentCardRef.value) paymentCardRef.value.scrollLeft = 0
      if (durationCardRef.value) durationCardRef.value.scrollLeft = 0
    }, 100)
  })
}

const scrollPlanCardToCenter = (event) => {
  const card = event?.currentTarget
  const container = card?.parentElement
  if (!(card instanceof HTMLElement) || !(container instanceof HTMLElement)) return
  if (container.scrollWidth <= container.clientWidth + 1) return

  nextTick(() => {
    requestAnimationFrame(() => {
      const containerRect = container.getBoundingClientRect()
      const cardRect = card.getBoundingClientRect()
      const targetLeft = container.scrollLeft
        + cardRect.left
        - containerRect.left
        - (container.clientWidth - cardRect.width) / 2
      const maxScrollLeft = container.scrollWidth - container.clientWidth

      container.scrollTo({
        left: Math.max(0, Math.min(targetLeft, maxScrollLeft)),
        behavior: 'smooth'
      })
    })
  })
}

watch(
  () => [currentMemberType.value, currentSelectDuration.value],
  () => {
    if (visibleTabCount.value <= 0) return
    handleTabClick(currentMemberType.value, currentSelectDuration.value)
  }
)

const MEMBER_PAGE_SCROLLBAR_CLASS = 'member-page-no-scrollbar'

const lockPageScrollbar = () => {
  document.documentElement.classList.add(MEMBER_PAGE_SCROLLBAR_CLASS)
  document.body.classList.add(MEMBER_PAGE_SCROLLBAR_CLASS)
}

const unlockPageScrollbar = () => {
  document.documentElement.classList.remove(MEMBER_PAGE_SCROLLBAR_CLASS)
  document.body.classList.remove(MEMBER_PAGE_SCROLLBAR_CLASS)
}

onMounted(() => {
  lockPageScrollbar()
  startCountdown()
  startLimitedTimeCountdown()
  getchargeCatalog(currentMemberType.value, currentSelectDuration.value)
  getMemberEquity()
  window.addEventListener(COUPON_CLAIM_SUCCESS_EVENT, refreshMemberPageAfterCouponClaim)
})

onUnmounted(() => {
  unlockPageScrollbar()
  stopPolling()
  stopCountdown()
  stopLimitedTimeCountdown()
  if (planPriceAnimationDelayTimer) clearTimeout(planPriceAnimationDelayTimer)
  if (planPriceAnimationFrame) cancelAnimationFrame(planPriceAnimationFrame)
  window.removeEventListener('mousemove', handleMouseMove)
  window.removeEventListener('mouseup', handleMouseUp)
  window.removeEventListener('mousemove', handleTeamSubListMouseMove)
  window.removeEventListener('mouseup', handleTeamSubListMouseUp)
  window.removeEventListener(COUPON_CLAIM_SUCCESS_EVENT, refreshMemberPageAfterCouponClaim)
})
</script>

<style lang="scss" scoped>
.member-page {
  --member-brand: #ff4646;
  --member-orange: #ff6b3f;
  --member-brown: #851A00;
  --member-ink: #1d1f26;
  --member-soft: #fdf8f4;
  --member-line: #ffe7da;
  min-height: 100%;
  overflow-x: hidden;
  background: linear-gradient(180deg, #fff0f0 0%, rgba(248, 248, 248, 0.9) 42%, #f8f8f8 100%);
  color: var(--member-ink);
}

.member-page-main {
  width: 1410px;
  max-width: calc(100vw - 48px);
  min-width: 0;
  margin: 0 auto;
  padding: 22px 0 86px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
}

.member-pay-panel {
  width: 270px;
  flex: 0 0 270px;
  padding: 23px 13px;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
  position: sticky;
  top: 16px;
  align-self: flex-start;
}

.member-content {
  width: calc(100% - 286px);
  flex: 1 1 auto;
  min-width: 0;
}

.content-card {
  padding: 0 48px 60px;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.content-card-title {
  height: 69px;
  margin: 0;
  padding: 24px 0 17px;
  border-bottom: 1px solid #F7F6FA;
  color: var(--member-ink);
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  box-sizing: border-box;
}

.countdown-section {
  width: 220px;
  margin: 0 auto;
  padding-bottom: 20px;
  border-bottom: 1px dashed #ffccb1;
  text-align: center;
}

.countdown-title {
  margin: 0 0 12px;
  color: var(--member-brown);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.countdown-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.time-box {
  min-width: 38px;
  height: 32px;
  padding: 0 8px;
  border-radius: 8px;
  background: #feefe7;
  color: var(--member-brown);
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  box-sizing: border-box;
}

.time-dot {
  width: 8px;
  color: var(--member-brown);
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
}

.price-section {
  padding: 16px 0 4px;
  text-align: center;
}

.pay-price-label {
  width: 106px;
  height: 26px;
  margin: 0 auto 4px;
  border-radius: 43px;
  background: var(--member-soft);
  color: #94522d;
  font-size: 14px;
  line-height: 26px;
}

.pay-price {
  color: var(--member-brand);
  font-size: 40px;
  font-weight: 800 !important;
  line-height: 56px;
}

.pay-price-symbol {
  margin-right: 4px;
  font-family: inherit !important;
  font-size: 24px;
  font-weight: inherit !important;
}

.qr-section {
  text-align: center;
}

.qr-box {
  width: 146px;
  height: 146px;
  margin: 0 auto 8px;
  padding: 14px;
  border: 1px solid #ffecd4;
  border-radius: 16px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

}

.qr-iframe {
  width: 115px;
  height: 120px;
  transform: scale(0.94);
  transform-origin: center;
}

.qr-empty {
  width: 110px;
  height: 110px;
  background: linear-gradient(135deg, #f4f4f4, #fff);
}

.qr-tip {
  color: var(--member-brown);
  font-size: 14px;
  line-height: 20px;
}

.order-card,
.coupon-card,
.pay-method-card {
  border: 1px solid var(--member-line);
  border-radius: 8px;
  background: var(--member-soft);
  box-sizing: border-box;
}

.order-card {
  min-height: 102px;
  margin-top: 16px;
  padding: 8px 12px;
}

.pay-method-card {
  min-height: 185px;
  margin-top: 12px;
  padding: 8px 12px 14px;
}

.panel-card-title {
  height: 28px;
  margin: 0 0 4px;
  color: var(--member-brown);
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
}

.order-row {
  height: 28px;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgba(29, 31, 38, 0.6);
  font-size: 14px;
  line-height: 20px;

}

.order-row-value {
  max-width: 132px;
  overflow: hidden;
  color: inherit;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.discount-text {
  color: var(--member-brand);
}

.coupon-card {
  width: 100%;
  height: 44px;
  margin-top: 12px;
  padding: 0 12px;
  border: 1px solid var(--member-line);
  border-radius: 8px;
  appearance: none;
  background: var(--member-soft);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(29, 31, 38, 0.6);
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  cursor: pointer;

  &::after {
    content: '›';
    margin-left: 2px;
    color: rgba(29, 31, 38, 0.45);
    font-size: 20px;
    line-height: 1;
  }

}

.coupon-card-value {
  margin-left: auto;
  color: var(--member-brand);
  font-weight: 500;
}

.coupon-icon {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background: linear-gradient(135deg, #ff8f68 0%, #ff4646 100%);
  color: #fff;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
}

.pay-method {
  width: 100%;
  height: 44px;
  margin-top: 8px;
  padding: 0 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--member-ink);
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  transition: border-color 0.16s ease, background 0.16s ease;

  .check-mark {
    width: 16px;
    height: 16px;
    margin-left: auto;
    border: 1px solid rgba(29, 31, 38, 0.12);
    border-radius: 50%;
    background: #fff;
    box-sizing: border-box;
  }

  &.active {
    border-color: rgba(75,55,19,0.7);
    background: #fff8f8;

    .check-mark {
      // border: 4px solid var(--member-brand);
      // background: #fff;
      border: none;
    background: url('@/assets/images/member/pay_check.png') center / contain no-repeat;

    }
  }
}

.pay-method-icon {
  width: 24px;
  height: 24px;
}

.policy-text {
  margin-top: 12px;
  text-align: center;
  color: var(--member-brown);
  font-size: 12px;
  line-height: 17px;

}

.policy-text-link {
  font-size: 12px;
  color: #1858F7;
  text-decoration: none;
}

.profile-banner {
  position: relative;
  height: 116px;
  margin: 16px 0 32px;
  padding: 17px 32px;
  border-radius: 12px;
  background:
    linear-gradient(90deg, rgba(255, 250, 243, 0.98) 0%, rgba(255, 246, 235, 0.86) 42%, rgba(255, 246, 235, 0.08) 68%),
    url('@/assets/images/member/member_bg_img1.png') right center / auto 116px no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  box-sizing: border-box;

  &::before {
    display: none;
  }
}

.profile-left {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}

:deep(.profile-left .el-avatar) {
  background-color: transparent;
}

.profile-name {
  color: var(--member-brown);
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.profile-id {
  margin-top: 0;
  color: rgba(29, 31, 38, 0.6);
  font-size: 14px;
  line-height: 22px;
}

.profile-vip {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;

}

.profile-vip-badge {
  min-width: 81px;
  height: 24px;
  padding: 0 10px 0 26px;
  border-radius: 41px;
  background: linear-gradient(90deg, #ff7065 0%, #ff3b3a 100%);
  color: #fff6e0;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  position: relative;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 5px;
    width: 14px;
    height: 14px;
    background: url('@/assets/images/member/vip.png') center / contain no-repeat;
  }
}

.profile-vip-expire {
  color: rgba(29, 31, 38, 0.6);
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
}

.diamond-area {
  position: relative;
  z-index: 1;
  width: 420px;
  height: 116px;
  margin-right: -4px;
  background: transparent;

  &::before {
    display: none;
  }
}

.member-tabs-container {
  min-height: 286px;
  // border: 1px solid #ffc674;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;

  :deep(.el-tabs__header) {
    margin: 0;
  }

  :deep(.el-tabs__nav-wrap::after),
  :deep(.el-tabs__active-bar) {
    display: none;
  }

  :deep(.el-tabs__nav-scroll),
  :deep(.el-tabs__nav) {
    width: 100%;
    margin-bottom: 0.5px;
  }

  :deep(.el-tabs__nav) {
    display: flex;
    gap: 8px;
  }

  :deep(.el-tabs__item) {
    width: 100%;
    height: 60px;
    padding: 0;
    border: 0;
  }

  :deep(.el-tabs__item .tab-label) {
    width: 100%;
    height: 60px;
    padding: 7px 28px;
    border: 0;
    background: linear-gradient(180deg, #FEFAF4 0%, #FEFAF4 100%);
    border-radius: 24px 24px 0px 0px;
  }

  :deep(.el-tabs__item.is-active .tab-label) {
    position: relative;

    border-bottom-width: 0px;

    .tab-title {
      display: block;
      color: var(--member-brown);
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
    }

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: linear-gradient(180deg, rgba(255, 186, 68, 1), rgba(255, 199, 104, 0));
      z-index: 1;
    }

    &::after {
      content: "";
      position: absolute;
      inset: 1px;
      border-radius: inherit;
      background: linear-gradient(93deg, #FDF5E7 0%, #FFEEDF 49.68%, #FFF8F2 100%);
      z-index: 1;
    }
  }

  :deep(.el-tabs__content) {
    min-height: 226px;
    background: linear-gradient(180deg, #FEFAF3 0%, #FDFDFC 100%);
    border: 1px solid #FDF1DE;
    border-radius: 0px 0px 24px 24px;
  }

  :deep(.el-tab-pane) {
    height: auto;
  }

  &.single-tab-title {
    :deep(.el-tabs__nav) {
      gap: 0;
    }

    :deep(.el-tabs__item) {
      cursor: default;
    }

    :deep(.tab-label) {
      padding-right: 40px;
    }

    :deep(.tab-info) {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;
      min-width: 0;
    }

    :deep(.tab-desc) {
      margin: 0;
      color: #a86e66;
      text-align: right;
    }
  }
}

.tab-label {
  position: relative;
  width: 100%;
  height: 60px;
  padding: 7px 28px;
  border: 1px solid transparent;
  border-bottom-color: rgba(255, 198, 116, 0.3);
  background: linear-gradient(0deg, #FEFAF4 0%, #FEFAF4 100%);
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  box-sizing: border-box;
  z-index: 2;

}

.tab-title {
  display: block;
  color: #1D1F26;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}

.tab-desc {
  margin: 4px 0 0;
  color: rgba(29, 31, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}

.tab-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border: 0;
  border-radius: 50%;
  background: url('@/assets/images/member/vip.png') center / contain no-repeat;
  color: transparent;
  line-height: 32px;
  text-align: center;
  font-size: 0;
  z-index: 2;

  &.gift {
    background: url('@/assets/images/member/member_liwu_icon1.png') center / contain no-repeat;
  }
}

.tab-info {
  z-index: 2
}

.plans-panel {
  padding: 24px 0 32px 32px;
}

.integral-panel {
  padding-top: 20px;
  padding-bottom: 20px;
}

.integral-plan-group {
  min-height: 198px;

  &+.integral-plan-group {
    margin-top: 20px;
  }
}

.plans-head {
  height: 24px;
  margin: 0 12px 10px 0;
  padding-left: 12px;
  display: flex;
  justify-content: space-between;

  .plans-head-title {
    color: var(--member-brown);
    font-size: 16px;
    line-height: 24px;
  }

}

.plans-head-link {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: var(--member-brown);
  text-decoration: none;
}

.duration-head {
  margin-top: 0;
}

.payment-card {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  margin: -12px -32px -50px;
  padding: 12px 32px 50px;
  scrollbar-width: none;

  &::after {
    content: '';
    flex: 0 0 12px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.card-item {
  position: relative;
  width: 278px;
  min-width: 278px;
  height: 162px;
  border: 2px solid #F6F6F6;
  border-radius: 24px;
  background: #F6F6F6;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  transition: border-color 0.16s ease, background 0.16s ease;

  &.active {
    border-color: #FFE3B0;
    background: #FFE3B0;
    box-shadow: 0px 19px 31px 0px rgba(62, 39, 12, 0.08);

    .card-main {
      background: #FEF8EF;
    }

    .card-name,
    .price-row-amount {
      color: #c62e00;
    }

    .price-row-original {
      color: #E45C31;
    }

    .select-corner {
      // border-color: #d76017;
      // background: #d76017;
      border: none;
      background: url('@/assets/images/member/pay_check.png') center / contain no-repeat;

      // &::after {
      //   opacity: 1;
      // }
    }

    .card-item-desc {
      color: var(--member-brown);
    }
  }

}

.card-item-desc {
  height: 52px;
  margin: 0;
  padding: 16px 58px 0 20px;
  color: rgba(29,31,38,0.6);
  font-size: 14px;
  line-height: 20px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}

.card-main {
  height: 110px;
  padding: 21px 28px;
  background: #fff;
  border-radius: 24px 24px 0 0;
  box-sizing: border-box;
}

.card-name {
  height: 22px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--member-ink);
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  // span{
  //   font-size: inherit !important;
  // }

}

.card-name-txt {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}

.card-name-badge {
  width: auto;
  height: 20px;
}

.price-row {
  margin-top: 12px;
  display: flex;
  align-items: flex-end;
  gap: 7px;
  white-space: nowrap;

}

.price-row-amount {
  color: var(--member-ink);
  font-size: 32px;
  font-weight: 800 !important;
  line-height: 34px;
}

.price-row-symbol {
  margin-right: 4px;
  font-family: inherit !important;
  font-size: 18px;
  font-weight: inherit !important;
  line-height: 22px;
}

.price-row-tag {
  height: 16px;
  padding: 0 6px;
  margin-bottom: 4px;
  border-radius: 4px;
  background: #fede96;
  color: var(--member-brand);
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
}

.price-row-original,
.price-row-vip {

  font-size: 14px;
  color: rgba(29, 31, 38, 0.6);
}

.price-row-vip {
  text-decoration: none;
}

.hot-buy {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 10px;
  height: 24px;
  padding: 0 16px;
  background: #FF944D;
  border-radius: 0px 24px 0px 12px;
  font-weight: normal;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
}

.select-corner {
  position: absolute;
  right: 20px;
  bottom: 14px;
  width: 24px;
  height: 24px;
  border: 1px solid rgba(29, 31, 38, 0.12);
  border-radius: 50%;
  background: #fff;
  box-sizing: border-box;

  // &::after {
  //   content: '';
  //   position: absolute;
  //   left: 8px;
  //   top: 5px;
  //   width: 6px;
  //   height: 10px;
  //   border: solid #fff;
  //   border-width: 0 2px 2px 0;
  //   opacity: 0;
  //   transform: rotate(45deg);
  // }
}

.rights-compare,
.template-section,
.gift-section,
.team-section,
.integral-rights {
  margin-top: 16px;
}

.member-section-title {
  height: 34px;
  margin: 0 0 16px;
  padding: 10px 4px 0;
  color: var(--member-ink);
  font-size: 16px;
  line-height: 24px;
  box-sizing: border-box;
}

.member-section-title-accent {
  font-family: inherit;
  font-size: inherit;
  font-weight: 600;
  line-height: inherit;
  color: #1858F7;
}

.rights-compare {
  margin-top: 16px;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 16px;

    .member-section-title {
      margin: 0;
    }
  }
}

.compare-table {
  border: 1px solid #F8F1E4;
  border-radius: 16px;
  // background: var(--member-soft);
  overflow: hidden;
}

.compare-table-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.compare-row {
  min-height: 44px;
  display: grid;
  grid-template-columns: minmax(150px, 2.6fr) repeat(var(--rights-column-count), minmax(112px, 1.65fr));
  align-items: center;
  min-width: calc(150px + var(--rights-column-count) * 112px);
  border-bottom: 1px solid rgba(255, 231, 218, 0.72);
  text-align: center;
  // 
  // font-weight: 500;
  font-size: 14px;
  color: #1D1F26;
  line-height: 22px;

  .compare-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-family: 'AlibabaPuHuiTi-Regular';
  }

  &:last-of-type {
    border-bottom: 0;
  }

  &.compare-head {
    min-height: 52px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FEF8EF 100%);
    color: var(--member-ink);

    .compare-cell {
      font-weight: 900;
    }
  }

  .rights-column-title {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-weight: 900;

  }

  .compare-cell-name {
    position: sticky;
    left: 0;
    z-index: 2;
    padding-left: 24px;
    background: #fff;
    box-shadow: 8px 0 16px rgba(120, 84, 52, 0.06);
    text-align: left;
  }

  &.compare-head .compare-cell-name {
    z-index: 3;
    background: linear-gradient(180deg, #FFFFFF 0%, #FEF8EF 100%);
  }

  .compare-cell.current,
  .rights-column-title.current {
    background: #FFF6F1;
  }

  .rights-column-title.current {
    color: #851A00;
  }

  .green {
    color: #12B912;
  }
}

.rights-column-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  object-fit: contain;
}

.rights-status-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  object-fit: contain;
  vertical-align: middle;
}

.rights-cell-text,
.rights-cell-sub-text {
  display: block;
  text-align: center;
  line-height: 20px;
}

.rights-cell-sub-text {
  margin-top: 2px;
}

.expand-btn {
  width: 100%;
  height: 44px;
  border: 0;
  background: #FFFCF9;
  color: var(--member-brown);
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.expand-arrow {
  width: 8px;
  height: 8px;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: translateY(-2px) rotate(45deg);
  transition: transform 0.16s ease;

  &.up {
    transform: translateY(2px) rotate(225deg);
  }
}

.gift-grid,
.rights-grid {
  display: grid;
  gap: 20px;
}

.template-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  padding-bottom: 2px;

  &.scrollable {
    display: flex;
    overflow-x: auto;
    scrollbar-width: none;

    &::after {
      content: '';
      flex: 0 0 12px;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .template-card {
      flex: 0 0 241px;
    }
  }
}

.template-card {
  height: 194px;
  padding: 12px;
  border: 1px solid var(--member-line);
  border-radius: 12px;
  background: var(--member-soft);
  box-sizing: border-box;
  cursor: pointer;

}

.template-card-title {
  display: block;
  margin: 8px 4px 2px;
  color: var(--member-brown);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.template-card-desc {
  margin: 0 4px;
  color: rgba(29, 31, 38, 0.6);
  font-size: 12px;
  line-height: 17px;
}

.template-thumb {
  position: relative;
  height: 123px;
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(255, 249, 238, 0.96) 0%, rgba(255, 232, 199, 0.9) 52%, rgba(255, 212, 166, 0.96) 100%);
  background-position: center;
  background-size: cover;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0);
  }

  &.locked::before {
    background: rgba(0, 0, 0, 0.4);
  }
}

.template-thumb-badge {
  position: absolute;
  left: 8px;
  top: 8px;
  display: flex;
  align-items: center;
  width: 78px;
  height: 24px;
  padding-left: 24px;
  background: linear-gradient(270deg, #595959 0%, #3A3838 100%);
  border-radius: 41px;
  font-weight: normal;
  font-size: 12px;
  color: #FFD68D;
  box-sizing: border-box;
  z-index: 2;
}

.template-thumb-badge::before {
  content: '';
  position: absolute;
  left: 7px;
  top: 4px;
  width: 14px;
  height: 14px;
  background: url('@/assets/images/member/vip.png') center / contain no-repeat;
}

.lock {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
}

.gift-grid {
  grid-template-columns: repeat(2, 1fr);
}

.gift-card {
  min-height: 90px;
  padding: 12px 24px;
  border: 1px solid var(--member-line);
  border-radius: 12px;
  background: var(--member-soft);
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;

  .gift-info {
    display: flex;
    flex-direction: column;
  }

}

.gift-title {
  color: var(--member-brown);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.gift-desc {
  align-self: flex-start;
  display: inline-flex;
  min-height: 24px;
  margin: 6px 0 0;
  padding: 2px 12px;
  border: 1px solid rgba(50,108,255,0.1);
  border-radius: 40px;
  background: linear-gradient( 270deg, #E5F9FF 0%, #FFFFFF 52.12%, #E5F9FF 100%);
  color: #1858F7;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
}

.gift-logo,
.rights-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: transparent;
  flex-shrink: 0;
  overflow: hidden;

}

.gift-logo-img,
.rights-icon-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.gift-action {
  width: 60px;
  height: 32px;
  margin-left: auto;
  border: 0;
  border-radius: 10px;
  background: linear-gradient( 180deg, #3E2F1C 0%, #25221D 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.team-section {
  margin-top: 16px;
}

.team-section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.team-share-rule-entry {
  height: 24px;
  margin-bottom: 12px;
  padding: 0 10px;
  border: 1px solid rgba(255, 98, 73, 0.28);
  border-radius: 12px;
  background: #fff8f4;
  color: #ff6249;
  font-size: 13px;
  line-height: 22px;
  cursor: pointer;
  box-sizing: border-box;
}

.team-card {
  min-height: 190px;
  padding: 16px;
  border: 1px solid var(--member-line);
  border-radius: 12px;
  background: var(--member-soft);
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr);
  gap: 24px;
  box-sizing: border-box;

  &::before {
    content: '';
    grid-column: 2;
    grid-row: 1;
    width: 1px;
    height: 150px;
    margin-top: 4px;
    background: rgba(255, 107, 63, 0.1);
  }
}

.sub-accounts {
  grid-column: 1;
}

.team-card-head {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgba(29, 31, 38, 0.6);
  font-size: 14px;

}

.team-card-head-title {
  color: var(--member-brown);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}

.team-card-head-desc {
  margin-left: 8px;
  color: rgba(29, 31, 38, 0.6);

  font-style: normal;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.team-card-head-highlight {
  color: #FF4646;

  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.sub-list {
  height: 120px;
  margin-top: 16px;
  display: flex;
  align-items: stretch;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  cursor: grab;
  user-select: none;

  &.dragging {
    cursor: grabbing;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.arrow-btn {
  display: none;
}

.sub-account {
  position: relative;
  width: calc((100% - 24px) / 3);
  min-width: calc((100% - 24px) / 3);
  height: 120px;
  border: 1px dashed rgba(255, 107, 63, 0.6);
  border-radius: 12px;
  background: linear-gradient(245deg, #fffcf9 8%, #fff 99%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(29, 31, 38, 0.6);
  box-sizing: border-box;
}

.sub-account-avatar-text {
  width: 40px;
  height: 40px;
  border: 1px solid #fff;
  border-radius: 50%;
  background: #fddad4;
  color: var(--member-brand);
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
}

.sub-account-name {
  margin-top: 12px;
  color: var(--member-ink);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.sub-account-id {
  margin-top: 2px;
  color: rgba(29, 31, 38, 0.6);
  font-size: 12px;
  line-height: 17px;
}

.sub-account {
  &.active {
    border-style: solid;
    border-color: #ff7f47;
    background: linear-gradient(245deg, #fffaf4 8%, #fef3e2 99%);
  }

  &.blue {
    .sub-account-avatar-text {
      background: #dcecff;
      color: #3478f6;
    }
  }

  &.add {
    color: var(--member-brand);
    font-size: 32px;
    line-height: 1;
    cursor: pointer;

    .sub-account-add-icon {
      width: 40px;
      height: 40px;
      display: block;
    }

    .sub-account-add-text {
      display: block;
      margin-top: 12px;
      color: rgba(29, 31, 38, 0.6);
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.account-crown {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 44px;
  height: 20px;
  object-fit: contain;
}

.invite-panel {
  grid-column: 3;
  border-left: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.invite-panel-title {
  color: var(--member-brown);
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}

.invite-panel-desc {
  margin: 8px 0 14px;
  color: rgba(29, 31, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
}

.invite-panel-tip {
  display: block;
  margin-top: 12px;
  color: rgba(50,108,255,0.8);
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
}

.invite-input {
  height: 54px;
  padding: 11px 8px 11px 12px;
  border: 1px solid rgba(255, 107, 63, 0.2);
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;

}

.invite-input-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.invite-input-field {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  color: rgba(29, 31, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  font-style: normal;
  &::placeholder {
    color: rgba(29, 31, 38, 0.4);
    font-size: 14px;
    line-height: 20px;
    font-style: normal;
}

}

.invite-input-button {
  width: 88px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient( 180deg, #3E2F1C 0%, #25221D 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.integral-rights {
  margin-top: 16px;
}

.rights-grid {
  grid-template-columns: repeat(4, 1fr);
}

.rights-item {
  min-height: 80px;
  padding: 10px 12px;
  border: 1px solid var(--member-line);
  border-radius: 12px;
  background: var(--member-soft);
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;

}

.rights-item-title {
  color: var(--member-brown);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.rights-item-desc {
  margin: 6px 0 0;
  color: rgba(29, 31, 38, 0.6);
  font-size: 12px;
  line-height: 17px;
}

.dialog-title {
  width: 100%;
  margin-top: 4px;
  text-align: center;
  color: #000;
  font-size: 18px;
  font-weight: 700;
}

.dialog-content {
  margin-bottom: 18px;
  text-align: center;
  color: #362f2f;
  font-size: 16px;
  font-weight: 600;
}

.dialog-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 8px;
}

.team-confirm-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.team-confirm-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.team-confirm-dialog {
  width: 406px;
  padding: 24px 0;
  border-radius: 16px;
  background: linear-gradient(180deg, #fff4e7 0%, #fffbf8 100%);
  box-sizing: border-box;
  overflow: hidden;
}

.team-confirm-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;

}

.team-confirm-desc {
  min-width: 100%;
  margin: 0;
  color: rgba(133, 26, 0, 0.7);
  font-size: 14px;

  line-height: normal;
  text-align: center;
}

.team-confirm-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

}

.team-confirm-title-text {
  color: #812d18;
  font-size: 18px;
  font-weight: 900;
  line-height: normal;
  white-space: nowrap;
}

.team-confirm-title-icon {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
}

.team-confirm-body {
  width: 100%;
  margin-top: 20px;
  padding: 0 16px 0 20px;
  box-sizing: border-box;
}

.team-confirm-info {
  width: 100%;
  border: 1px solid #fff;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  overflow: hidden;
}

.team-confirm-row {
  height: 56px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  color: rgba(29, 31, 38, 0.5);
  font-size: 14px;
  line-height: normal;
  text-align: center;
  white-space: nowrap;

}

.team-confirm-row-value {
  font-weight: normal;
  color: #1d1f26;
  font-size: 14px;
}

.team-confirm-actions {
  width: 100%;
  margin-top: 20px;
  padding: 0 20px;
  box-sizing: border-box;

}

.team-confirm-button {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(90deg, #ff4b25 0%, #ff8e56 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.72;
  }
}

.team-confirm-close {
  width: 34px;
  height: 34px;
  cursor: pointer;
}

.team-share-rule-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.team-share-rule-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.team-share-rule-dialog {
  position: relative;
  width: 486px;
  min-height: 330px;
  padding: 14px 12px 16px;
  border-radius: 16px;
  background: linear-gradient( 0deg, #FEF7F1 0%, #FEF3E3 100%);
  box-sizing: border-box;
}

.team-share-rule-top-img {
  position: absolute;
  top: -30px;
  right: 0;
  width: 139px;
  height: 78px;
  display: block;
  object-fit: contain;
  pointer-events: none;
}

.team-share-rule-content {
  padding: 0 4px;
}

.team-share-rule-title {
  display: block;
  color: #644628;
  font-size: 18px;
  line-height: 25px;
}

.team-share-rule-list {
  margin-top: 13px;
  padding: 12px;
  border: 1px solid #fff;
  border-radius: 16px;
  background: #FDFCF9;
  box-sizing: border-box;
}

.team-share-rule-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.team-share-rule-item+.team-share-rule-item {
  margin-top: 16px;
}

.team-share-rule-index {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  border-radius: 50%;
  background: #FEEED6;
  color: #851A00;
  flex: 0 0 18px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
}

.team-share-rule-text {
  margin: 0;
  color: #1D1F26;
  font-size: 14px;
  line-height: 20px;
}

.team-share-rule-highlight {
  color: #FF6B3F;
  font-style: normal;
}

.team-share-rule-close {
  width: 34px;
  height: 34px;
  cursor: pointer;
}

@media (max-width: 1280px) {
  .member-page-main {
    width: auto;
    max-width: calc(100vw - 32px);
    gap: 12px;
  }

  .member-pay-panel {
    width: 252px;
    flex-basis: 252px;
  }

  .member-content {
    width: calc(100% - 264px);
  }

  .content-card {
    padding: 0 32px 52px;
  }

  .card-item {
    width: 244px;
    min-width: 244px;
  }

  .card-main {
    padding-left: 22px;
    padding-right: 22px;
  }

  .compare-row {
    grid-template-columns: minmax(136px, 2.2fr) repeat(var(--rights-column-count), minmax(104px, 1fr));
    min-width: calc(136px + var(--rights-column-count) * 104px);

    .compare-cell {
      font-size: 15px !important;
      font-weight: 400 !important;
    }
  }
}

@media (max-width: 960px) {
  .member-page-main {
    max-width: calc(100vw - 24px);
    padding-top: 12px;
    flex-direction: column;
  }

  .member-pay-panel {
    position: static;
    width: 100%;
    flex: 0 0 auto;
  }

  .member-content {
    width: 100%;
    flex: 0 0 auto;
  }

  .content-card {
    padding: 0 20px 44px;
  }
}

@media (max-width: 640px) {
  .member-page-main {
    max-width: calc(100vw - 16px);
    padding-bottom: 48px;
  }

  .content-card {
    padding: 0 12px 36px;
    border-radius: 8px;
  }

  .content-card-title {
    height: 56px;
    padding-top: 18px;
    font-size: 18px;
  }

  .rights-compare .title {
    align-items: flex-start;
  }

  .compare-row {
    grid-template-columns: 116px repeat(var(--rights-column-count), 96px);
    min-width: calc(116px + var(--rights-column-count) * 96px);

    .compare-cell-name {
      padding-left: 14px;
    }
  }

  .rights-column-icon {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
  }
}

</style>

<style lang="scss">
html.member-page-no-scrollbar,
body.member-page-no-scrollbar {
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

html.member-page-no-scrollbar::-webkit-scrollbar,
body.member-page-no-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
</style>
